import { render } from "./AddDepartmentToCompanyAdmin.vue?vue&type=template&id=935d0f4e&scoped=true&ts=true"
import script from "./AddDepartmentToCompanyAdmin.vue?vue&type=script&lang=ts"
export * from "./AddDepartmentToCompanyAdmin.vue?vue&type=script&lang=ts"

import "./AddDepartmentToCompanyAdmin.vue?vue&type=style&index=0&id=935d0f4e&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-935d0f4e"]])

export default __exports__